/**
 * Attachment operation error types.
 * Used by repository to classify errors without mixing in presentation concerns.
 */
export enum AttachmentErrorType {
  FILE_TOO_LARGE = 'FILE_TOO_LARGE',
  FILE_TYPE_NOT_ALLOWED = 'FILE_TYPE_NOT_ALLOWED',
  CASE_CLOSED = 'CASE_CLOSED',
  UPLOAD_EXPIRED = 'UPLOAD_EXPIRED',
  NETWORK_ERROR = 'NETWORK_ERROR',
  S3_UPLOAD_FAILED = 'S3_UPLOAD_FAILED',
  UPLOAD_ABORTED = 'UPLOAD_ABORTED',
  PERMISSION_DENIED = 'PERMISSION_DENIED',
  NOT_FOUND = 'NOT_FOUND',
  UNKNOWN = 'UNKNOWN',
}

/**
 * Structured attachment error.
 * Repository returns this instead of user-facing strings.
 * Application/presentation layers map to appropriate messages.
 */
export class AttachmentError extends Error {
  constructor(
    public readonly type: AttachmentErrorType,
    public readonly originalMessage: string,
    public readonly statusCode?: number
  ) {
    super(originalMessage);
    this.name = 'AttachmentError';
  }
}
